/**
 * Region name → URL slug mapping for directory pages.
 * Mirrors the REGION_MAP in firmindex-api/src/routes/directory/directory.handlers.ts.
 */
const REGION_SLUG_MAP: Record<string, string> = {
	"Hlavní město Praha": "praha",
	"Středočeský kraj": "stredocesky",
	"Jihočeský kraj": "jihocesky",
	"Plzeňský kraj": "plzensky",
	"Karlovarský kraj": "karlovarsky",
	"Ústecký kraj": "ustecky",
	"Liberecký kraj": "liberecky",
	"Královéhradecký kraj": "kralovehradecky",
	"Pardubický kraj": "pardubicky",
	"Kraj Vysočina": "vysocina",
	"Jihomoravský kraj": "jihomoravsky",
	"Olomoucký kraj": "olomoucky",
	"Zlínský kraj": "zlinsky",
	"Moravskoslezský kraj": "moravskoslezsky",
};

/** Convert a Czech region name to its URL slug. Returns null if not found. */
export function regionToSlug(regionName: string): string | null {
	return REGION_SLUG_MAP[regionName] ?? null;
}

/**
 * Extract the NACE section letter from a NACE code.
 * Company profiles have `naceCode` like "62010" — we need the section letter.
 * Since we don't have the mapping table client-side, we just return the code
 * as-is (the directory API handles both section letters and full codes).
 */
export function naceCodeToPath(naceCode: string): string {
	return naceCode;
}
